import { DevCycleOptions, initializeDevCycle } from '@devcycle/js-client-sdk'
import type { DevCycleUser, DevCycleClient } from '@devcycle/js-client-sdk'

const initializeDevCycleClient = (
    sdkKey: string,
    user: DevCycleUser = { isAnonymous: true },
    options?: DevCycleOptions,
): DevCycleClient => {
    if (options?.deferInitialization) {
        return initializeDevCycle(sdkKey, {
            sdkPlatform: 'react',
            ...options,
            deferInitialization: true, // make typescript happy
            bootstrapConfig: undefined,
        })
    }
    return initializeDevCycle(sdkKey, user, {
        sdkPlatform: 'react',
        ...options,
    })
}

export default initializeDevCycleClient
